import { ArrivalStatus, OrderSummary, TempRange, TripStatus } from '@asset-solutions/customer-portal/orders/models';
import { createFeature, createReducer, on } from '@ngrx/store';

import {
  changeOrderFilters,
  clearOrders,
  getOrdersSuccess,
  liveMapChangeOrderFilters,
  pollOrdersSuccess,
  resetCustomerIdsFilter
} from './orders.actions';

export interface OrdersState {
  arrivalStatus: ArrivalStatus[];
  customerIds: string[];
  fleetIds: string[];
  isAssigned: boolean[];
  orders: OrderSummary[];
  pickupEndDate: string | null;
  pickupStartDate: string | null;
  tempRange: TempRange[];
  tripStatus: TripStatus[];
}

export const getInitialState = (): OrdersState => ({
  arrivalStatus: [],
  customerIds: [],
  fleetIds: [],
  isAssigned: [],
  orders: [],
  pickupEndDate: null,
  pickupStartDate: null,
  tempRange: [],
  tripStatus: ['InTransit', 'Scheduled']
});

export const ordersFeature = createFeature({
  name: 'orders',
  reducer: createReducer(
    getInitialState(),
    on(changeOrderFilters, liveMapChangeOrderFilters, (state, { filters }): OrdersState => ({ ...state, ...filters })),
    on(getOrdersSuccess, pollOrdersSuccess, (state, { orders }): OrdersState => ({ ...state, orders })),
    on(resetCustomerIdsFilter, (state): OrdersState => ({ ...state, customerIds: [] })),
    on(clearOrders, (state): OrdersState => ({ ...state, orders: [] }))
  )
});

export const ordersFeatureKey = ordersFeature.name;
export const ordersFeatureReducer = ordersFeature.reducer;

export const {
  selectArrivalStatus,
  selectCustomerIds,
  selectFleetIds,
  selectIsAssigned,
  selectOrders,
  selectOrdersState,
  selectPickupEndDate,
  selectPickupStartDate,
  selectTempRange,
  selectTripStatus
} = ordersFeature;
